import { Link } from '@mui/material';
import Button from '../../../UI/Button/Button';

export default function Cta() {
  function gtag_report_conversion(url) {
    var callback = function () {
      if (typeof url != 'undefined') {
        window.location = url;
      }
    };
    // eslint-disable-next-line no-undef
    gtag('event', 'conversion', {
      send_to: 'AW-11121365082/jd1sCLjPwr0YENqgircp',
      event_callback: callback,
    });
    return false;
  }

  return (
    <section className='relative bg-primary-main'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        {/* Hero content */}
        <div className='pt-32 pb-12 md:pt-52 md:pb-32'>
          {/* Section header */}
          <div className='text-center pb-12 md:pb-16'>
            <h1 className='text-3xl md:text-6xl font-extrabold mb-4 text-white' data-aos='zoom-y-out'>
              Think you're a fit?
            </h1>
            <div className='max-w-3xl mx-auto'>
              <p className='text-xl text-white mb-8 font-montreal' data-aos='zoom-y-out' data-aos-delay='150'>
                Let's find out.
              </p>
              <div
                className='max-w-xs mx-auto sm:max-w-none sm:flex sm:justify-center'
                data-aos='zoom-y-out'
                data-aos-delay='300'>
                <div>
                  <Link
                    href='/payments'
                    onClick={() => {
                      gtag_report_conversion();
                      window.lintrk('track', { conversion_id: 13351812 });
                    }}
                    sx={{
                      textDecoration: 'none',
                    }}>
                    <Button text='Join Today' symbol='arrow' />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
